var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product"
  }, [_c('b-modal', {
    style: _vm.colorObject,
    attrs: {
      "id": "modal-info",
      "title": "取消換貨須知",
      "hide-footer": "",
      "centered": ""
    }
  }, [_c('p', [_vm._v(" 若訂購後有取消訂單/退貨需求，請登入會員於“我的訂單”點閱“訂單明細”。 選點申請取消訂單/退貨，提交申請後，請等待店家確認。 ")]), _c('p', [_vm._v(" 根據台灣消保法第十九條規範，享有收到商品後隔日起算七天猶豫期之權益(注意！猶豫期非試用期)商品退貨時必須回復原狀，亦即必須回復至您收到商品時的原始狀態 (包含主機、附件、內外包裝、隨機文件、贈品等)，若為部分商品退貨則針對您已使用或保留之商品應另以市價計價，否則將影響您退貨的權限。 提出申請後，經店家確認同意後，將會進行商品回收、退款/退刷等事項。 ")]), _c('p', [_vm._v(" 請注意，依消費者保護法第19條及行政院消費者保護處公告「通訊交易解除權合理例外情事適用準則」規定，以下商品不適用猶豫期，以避免日後紛爭。 ")])]), _c('b-modal', {
    attrs: {
      "id": "modal-purchase",
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "bodyClass": "p-0"
    }
  }, [_c('div', {
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "p-3 border-bottom purchase"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    staticClass: "img-fluid mr-2",
    attrs: {
      "src": "https://picsum.photos/500?".concat(_vm.i)
    }
  })])]), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("Rex│銀色反光偏光鏡片│墨鏡│太陽眼鏡")]), _c('span', {
    staticClass: "price"
  }, [_vm._v("NT$ 1,380")]), _c('span', {
    staticClass: "oprice ml-2"
  }, [_vm._v("NT$ 1,980")])])])]), _c('div', {
    staticClass: "p-3"
  }, [_vm._l(_vm.variants, function (v, vdx) {
    return _c('b-button', {
      key: vdx,
      staticClass: "m-2",
      attrs: {
        "variant": "outline-dark"
      }
    }, [_vm._v(" " + _vm._s(v) + " ")]);
  }), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-form-spinbutton', {
    staticClass: "text-center px-0",
    attrs: {
      "min": "1",
      "value": "1",
      "max": "100"
    }
  })], 1)], 2), _c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "size": "lg",
      "variant": "secondary"
    }
  }, [_vm._v(" 取消 ")])], 1), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "size": "lg",
      "variant": "primary"
    }
  }, [_vm._v(" 確定 ")])], 1)])])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isAddCart,
      "variant": "dark",
      "spinnerType": "none",
      "opacity": "0.5",
      "blur": "5px"
    },
    on: {
      "click": function click($event) {
        _vm.isAddCart = false;
      }
    }
  }, [_c('b-carousel', {
    attrs: {
      "interval": 4000,
      "controls": "",
      "background": "#ababab"
    },
    model: {
      value: _vm.slide,
      callback: function callback($$v) {
        _vm.slide = $$v;
      },
      expression: "slide"
    }
  }, [_vm._l(_vm.product.images, function (i) {
    return _c('b-carousel-slide', {
      key: i.id,
      attrs: {
        "img-src": i.pic_url
      }
    });
  }), _c('div', {
    staticClass: "indicators position-absolute text-white rounded-pill"
  }, [_vm._v(" " + _vm._s(_vm.slide + 1) + " / " + _vm._s(_vm.product.images.length) + " ")])], 2), _c('div', {
    staticClass: "p-3 shadow-sm"
  }, [_c('h1', {
    staticClass: "product__title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm.product.description ? _c('ul', {
    staticClass: "text-muted"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  })]) : _vm._e(), _vm.product.highlight ? _c('div', {
    staticClass: "highlight p-1 px-2 mb-3"
  }, [_vm._v(" " + _vm._s(_vm.product.highlight) + " ")]) : _vm._e(), _c('span', {
    staticClass: "price"
  }, [_vm._v("NT$ " + _vm._s(_vm.product.price))]), _c('span', {
    staticClass: "oprice ml-2"
  }, [_vm._v("NT$ " + _vm._s(_vm.product.original_price))])]), _c('div', {
    staticClass: "tab mt-3 shadow-sm"
  }, [_c('nav', {
    staticClass: "nav justify-content-around"
  }, [_c('a', {
    staticClass: "flex-fill text-sm-center nav-link h1 text-center",
    class: _vm.nav == 'detail' && 'active',
    attrs: {
      "role": "button"
    },
    on: {
      "click": function click($event) {
        _vm.nav = 'detail';
      }
    }
  }, [_vm._v("商品介紹")])]), _c('div', {
    staticClass: "p-3"
  }, [_vm.nav == 'detail' ? _c('div', [_c('h4', {
    staticClass: "h1 mb-3"
  }, [_vm._v("商品介紹")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.more_info)
    }
  })]) : _vm.nav == 'spec' ? _c('div', [_c('h4', {
    staticClass: "h1 mb-3"
  }, [_vm._v("規格說明")]), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-muted"
  }, [_vm._v("品牌")]), _c('td', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-fluid mr-2",
    attrs: {
      "src": "https://picsum.photos/50?".concat(_vm.i)
    }
  }), _vm._v(" 墨鏡人生 ")])])]), _c('tr', [_c('th', {
    staticClass: "text-muted"
  }, [_vm._v("規格")]), _c('td', [_vm._v("55-︎20-143")])]), _c('tr', [_c('th', {
    staticClass: "text-muted"
  }, [_vm._v("保存期限")]), _c('td', [_vm._v("10年")])]), _c('tr', [_c('th', {
    staticClass: "text-muted"
  }, [_vm._v("產地")]), _c('td', [_vm._v("臺灣")])]), _c('tr', [_c('th', {
    staticClass: "text-muted"
  }, [_vm._v("商品標籤")]), _c('td', [_c('span', {
    staticClass: "badge badge-pill bg-secondary px-3 m-1 h1"
  }, [_vm._v("女性")]), _c('span', {
    staticClass: "badge badge-pill bg-secondary px-3 m-1 h1"
  }, [_vm._v("精品")])])])])])]) : _vm._e()])]), _c('div', {
    staticClass: "p-3 shadow-sm"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("購物須知")]), _c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-info",
      modifiers: {
        "modal-info": true
      }
    }],
    staticClass: "d-block",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("點我了解付款與運費")]), _c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-info",
      modifiers: {
        "modal-info": true
      }
    }],
    staticClass: "d-block",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("點我了解取消換貨須知")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" 付款後，從備貨到寄出商品為 3 個工作天。（不包含假日） ")])])], 1), _c('footer', {
    staticClass: "fixed-bottom bg-white purchase mx-auto"
  }, [_vm.isAddCart ? _c('div', {
    staticClass: "p-3 border-bottom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    staticClass: "img-fluid mr-2",
    attrs: {
      "src": "https://picsum.photos/500?".concat(_vm.i)
    }
  })])]), _vm._m(0), _c('div', {
    staticClass: "col-12 mt-3"
  }, _vm._l(_vm.variants, function (v, vdx) {
    return _c('b-button', {
      key: vdx,
      staticClass: "m-2",
      attrs: {
        "variant": "outline-dark"
      }
    }, [_vm._v(" " + _vm._s(v) + " ")]);
  }), 1)])]) : _vm._e(), _c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [!_vm.isAddCart ? _c('b-button', {
    staticClass: "w-100",
    attrs: {
      "size": "lg",
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        _vm.isAddCart = true;
      }
    }
  }, [_vm._v(" 放入購物車 ")]) : _c('div', [_c('b-form-spinbutton', {
    staticClass: "text-center px-0",
    attrs: {
      "min": "1",
      "value": "1",
      "max": "100"
    }
  })], 1)], 1), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-purchase",
      modifiers: {
        "modal-purchase": true
      }
    }],
    staticClass: "w-100",
    attrs: {
      "size": "lg",
      "variant": "primary"
    }
  }, [_vm._v(" 直接購買 ")])], 1)])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("Rex│銀色反光偏光鏡片│墨鏡│太陽眼鏡")]), _c('span', {
    staticClass: "price"
  }, [_vm._v("NT$ 1,380")]), _c('span', {
    staticClass: "oprice ml-2"
  }, [_vm._v("NT$ 1,980")])]);
}]

export { render, staticRenderFns }